import { UnitType } from '@exodus/currency'

const name = 'litecoin'
const displayName = 'Litecoin'
const ticker = 'LTC'
const displayTicker = ticker
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#D6D6D6'
const gradientColors = ['#D6D6D6', '#777777']
const gradientCoords = { x1: '11.224%', y1: '-66.682%', x2: '141.81%', y2: '91.487%' }
const chainBadgeColors = gradientColors

const units = {
  latoshis: 0,
  LTC: 8,
}
const currency = UnitType.create(units)

// TODO enable once both desktop & mobile support it
// const useBip84 = false

const assetType = 'BITCOIN_LIKE'
const blockExplorer = {
  addressUrl: (address) => `https://live.blockcypher.com/ltc/address/${address}`,
  txUrl: (txId) => `https://live.blockcypher.com/ltc/tx/${txId}`,
}
const info = {
  description:
    "Litecoin is a cryptocurrency similar to Bitcoin. The goal of Litecoin is to provide fast transaction confirmations. Created by ex-Google employee Charlie Lee, Litecoin is often considered the silver to Bitcoin's gold.",
  reddit: 'https://www.reddit.com/r/litecoin/',
  twitter: 'https://twitter.com/LitecoinProject',
  website: 'https://litecoin.com/',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
